export default {
  computed: {
    reservableResourceTypes () {
      const types = [
        {
          value: 'generic',
          name: this._('Reservable resource'),
        },
        {
          value: 'cottage',
          name: this._('Cottage'),
        },
        {
          value: 'villa',
          name: this._('Villa'),
        },
        {
          value: 'accommodation',
          name: this._('Accommodation'),
        },
        {
          value: 'room',
          name: this._('Room'),
        },
        {
          value: 'meetingroom',
          name: this._('Meeting room'),
        },
        {
          value: 'space',
          name: this._('Space'),
        },
        {
          value: 'theater',
          name: this._('Theater'),
        },
        {
          value: 'vehicle',
          name: this._('Vehicle'),
        },
        {
          value: 'bicycle',
          name: this._('Bicycle'),
        },
        {
          value: 'motorcycle',
          name: this._('Motorcycle'),
        },
        {
          value: 'car',
          name: this._('Car'),
        },
        {
          value: 'bus',
          name: this._('Bus'),
        },
        {
          value: 'boat',
          name: this._('Boat'),
        },
        {
          value: 'plane',
          name: this._('Plane'),
        },
        {
          value: 'rentalgear',
          name: this._('Rental gear'),
        },
        {
          value: 'rentalequipment',
          name: this._('Rental equipment'),
        },
        {
          value: 'guide',
          name: this._('Guide'),
        }
      ]
      return types.sort((a, b) => a.name > b.name ? 1 : -1)
    }
  }
}